import { styled } from '@nykaa/ui-components';
import { Spinner } from '@nykaa/ui-components/Loader';
import { OVERLAY_ZINDEX } from 'shared/styles/base';
import { STICKY_CONTAINER_Z_INDEX } from './constants';
import ScrollToTopBase from 'shared/components/ScrollToTop';
import BreadCrumbsBase from 'shared/components/BreadCrumbs';

const FlexColumn = styled.div`
  display: flex;
  flex-direction: column;
`;

export const FilterAndContentContainer = styled(FlexColumn)`
  width: 80%;
`;

export const Wrapper = styled(FlexColumn)`
  flex: 1;
  margin: ${({ theme }) => `0 ${theme.spacing.spacing240} ${theme.spacing.spacing320} `};
`;

export const Filter = styled.div`
  min-height: 100vh;
  background-size: auto;
  width: 20%;
  padding-right: ${({ theme }) => theme.spacing.spacing240};
  background-color: ${({ theme }) => theme.colors.surface20};
`;

export const Title = styled.div`
  min-height: 24px;
  width: 300px;
  background-size: auto;
  background-color: ${({ theme }) => theme.colors.surface20};
  margin-bottom: ${({ theme }) => theme.spacing.spacing120};
`;

export const ListingContainerHeader = styled.div<{
  containerTop: number;
  isSticky: boolean;
  leftMargin: number;
}>`
  display: flex;
  justify-content: space-between;
  position: sticky;
  top: ${({ containerTop }) => `${containerTop}px`};
  z-index: ${STICKY_CONTAINER_Z_INDEX};
  display: flex;
  background-color: ${({ theme }) => theme.colors.surface};
  // on sticky styles
  ${({ isSticky, theme }) => isSticky && `border-bottom: 1px solid ${theme.colors.textOutline}`};
  padding: ${({ theme }) =>
    `${theme.spacing.spacing80} ${theme.spacing.spacing240} ${theme.spacing.spacing80} ${theme.spacing.spacing120}`};
  width: ${({ theme, isSticky, leftMargin }) =>
    `calc(100% + ${theme.spacing.spacing240} + ${
      isSticky ? `${leftMargin}px` : '0px'
    })`}; //adding spacing240 for right gutter to extend border bottom
  ${({ isSticky, leftMargin, theme }) =>
    isSticky &&
    `padding-left:calc(${theme.spacing.spacing120} + ${leftMargin}px)`}; // adding spacing120 because of left margin in product card
  ${({ isSticky, leftMargin }) => isSticky && `margin-left:-${leftMargin}px`};
`;

export const LoaderWrapper = styled.div`
  width: 100vw;
  height: 100%;
  display: flex;
  position: fixed;
  overflow: hidden;
  z-index: ${OVERLAY_ZINDEX};
  left: 0%;
  top: 0;
  align-items: center;
  justify-content: center;
`;

export const Loader = styled(Spinner)`
  border-radius: ${({ theme }) => theme.borders.radiusFull};
  background-color: ${({ theme }) => theme.colors.surface};
  circle {
    r: 17;
    stroke-width: 4px;
  }
`;

export const ListingContainer = styled.div`
  display: flex;
  width: 100%;
  margin: 0;
`;
export const FilterContainer = styled.div`
  margin: 0;
  min-width: 20%;
  max-width: 20%;
  position: relative;
  z-index: ${STICKY_CONTAINER_Z_INDEX - 1};
  padding-top: ${({ theme }) => theme.spacing.spacing80};
`;

export const ScrollToTop = styled(ScrollToTopBase)`
  bottom: 40px;
  right: 40px;
`;

export const BreadCrumb = styled(BreadCrumbsBase)`
  margin: 0;
`;
